import { LOCALSTORAGE_URL_API_KEY } from '@/_constants/keys';

export enum ENUM_NODE_ENV {
  ENV_PROD = 'production',
  ENV_STAGE = 'stage',
  ENV_DEV = 'developer',
}

export const { NODE_ENV } = import.meta.env;
export const FRONT_ENV = import.meta.env.REACT_APP_FRONT_ENV as ENUM_NODE_ENV;
export const GOOGLE_MAPS_EMBED_API_KEY = import.meta.env
  .REACT_APP_GOOGLE_MAPS_EMBED_API_KEY;
export const GOOGLE_MAPS_API_KEY = import.meta.env
  .REACT_APP_GOOGLE_MAPS_API_KEY;

export const SENTRY_DSN = import.meta.env.REACT_APP_SENTRY_DSN;

export const isProd = FRONT_ENV === ENUM_NODE_ENV.ENV_PROD;

function getApiUrl() {
  const localStorageApiUrl = localStorage.getItem(LOCALSTORAGE_URL_API_KEY);

  if (isProd || !localStorageApiUrl) {
    return import.meta.env.REACT_APP_API_URL;
  }

  return JSON.parse(localStorageApiUrl);
}

export const API_URL = getApiUrl();
